const _LOCAL_GTM = {
  budni: 'GTM-NX2RGMBT',
  alle: 'GTM-WH6KX2RL',
  kaufland: 'GTM-M76THVK',
  edeka: 'GTM-N35JSBT',
  gluecksrad: 'GTM-TCNXSGP3'
}

export default _LOCAL_GTM
